// 앱 전역 리포터 하나. ErrorBoundary·authDaemon·index.tsx 는 이것만 import 해 capture 를 부른다.
// onDrop 은 로컬에서만 콘솔에 남겨 "왜 안 갔지" 를 바로 보게 한다.

import {
  createReporter,
  resolveDropMode,
  resolveTagSampleRate,
} from '@mathflat/shared/@modules/errorReporting'

import { envUtils } from '@/utils/envUtils'

import { teacherPolicy } from './policy'
import { sentryAdapter } from './sentry'

// 한 기기가 끊긴 채 같은 자동 요청을 반복해도 세션당 이만큼만 보낸다
const NETWORK_REPEAT_LIMIT = 3

export const reporter = createReporter({
  policy: teacherPolicy,
  adapters: [sentryAdapter],
  debug: envUtils.isLocalDev,
  dropMode: resolveDropMode(import.meta.env.VITE_ERROR_REPORTING_DROP_MODE),
  tagSampleRate: resolveTagSampleRate(import.meta.env.VITE_ERROR_REPORTING_TAG_SAMPLE_RATE),
  networkRepeatLimit: NETWORK_REPEAT_LIMIT,
  onDrop: envUtils.isLocalDev
    ? (error) => console.info('[error-reporting] dropped', error.origin, error.code, error.message)
    : undefined,
})
